import type { Logger } from '@devhacker/shared/libs/logger';
import type { IAdsFormApi, IAdsFormPayload } from '~/types/api/ads-form';
import { parseData } from '@devhacker/shared/utils/parseData';
import { API_URL, API_TIMEOUT } from '~/constants/config';
import { adsFormSchema } from '~/schemas/adsFormSchema';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IAdsFormApi => {
  const adsFormFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}/wp-json/burninghut/`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    ...createLoggerInterceptors($logger, 'ads-form'),
  });

  return {
    async send(body: IAdsFormPayload) {
      const { data } = await adsFormFetch('ads-form', { method: 'POST', body });
      return parseData(data, adsFormSchema);
    },
  };
};
